import 'babel-polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router/'
import store from './store'
import i18n from './plugins/i18n'
import 'font-awesome/css/font-awesome.css'

import {LoadingPlugin} from "./plugins/loading"

Vue.config.productionTip = false

Vue.use(LoadingPlugin, {
    //props
    spinnerProps: {}
})

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
